import React from 'react'
import Login from "./Pages/auth/Login";
const { Route } = require("react-router-dom")


const PrivateRoute = ({ component, props, ...options }) => {
    const finalComponent = props.isUserAuthenticated ? component : Login;
    return <Route {...options} component={finalComponent} />;
}

export default PrivateRoute